import SelectorEngine from '../../utils/dom/selector-engine';
import BaseComponent from '../BaseComponent';
import EventHandler from '../../utils/dom/event-handler';
import Manipulator from '../../utils/dom/manipulator';

const NAME = 'LoginPrompt';
class LoginPrompt extends BaseComponent {
	constructor(element) {
		super(element);
		this.init();
	}

	static get NAME() {
		return NAME;
	}

	init() {
		const element = this._element;
		const { id: elementId, timestamp, ediPopup } = Manipulator.getDataAttributes(element);

		if (!elementId) return;

		const previousTimestamp = +sessionStorage.getItem(elementId);

		if (timestamp - previousTimestamp > 0) {
			// changes are made according to 33287
			//If the EDI Popup value is True, the EDI popup message should be displayed to the user.
			//If the user closes the popup, it should be hidden for the current session.
			//On the next login, the popup should not appear.
			//On the following login after that, the popup should appear again 
			// (i.e., it alternates visibility on subsequent logins if the user keeps closing it without updating the information).
			//If EDI popup is false we follow the usual process of storing the value in session storage and show the popup in next session.
			if (ediPopup) {
				let visitCount = localStorage.getItem(`${elementId}-visitCount`);
				let sessionExists = sessionStorage.getItem(`${elementId}-session`);

				if (!sessionExists) {

					if (visitCount === null) {
						visitCount = '1';
					} else {
						visitCount = visitCount === '1' ? '2' : '1';
					}
					localStorage.setItem(`${elementId}-visitCount`, visitCount);
					sessionStorage.setItem(`${elementId}-session`, 'true');
				}

				visitCount = localStorage.getItem(`${elementId}-visitCount`);

				if (visitCount === '2') {
					element.remove();
					return;
				}
				element.classList.remove('u-hidden');
			} else {
				element.classList.remove('u-hidden');
			}
		} else {
			element.remove();
			return;
		}

		const closeElement = SelectorEngine.findOne('.lta-login-prompt__close', element);

		EventHandler.on(closeElement, 'click', () => {
			sessionStorage.setItem(elementId, timestamp || 0);
			element.remove();
		});

		if (!sessionStorage.getItem(elementId)) {
			element.classList.remove('u-hidden');
		}
	}
}

export default LoginPrompt;
